import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '探索圈子',
    links: [
      { name: '旅行探险', path: '/category/travel' },
      { name: '美食烹饪', path: '/category/food' },
      { name: '数码科技', path: '/category/tech' },
      { name: '读书思考', path: '/category/reading' },
      { name: '运动健身', path: '/category/fitness' },
      { name: '艺术创作', path: '/category/art' },
    ],
  },
  {
    title: '关于社区',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '加入方法', path: '/about' },
      { name: '用户协议', path: '/about' },
      { name: '隐私政策', path: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { name: '常见问题', path: '/' },
      { name: '内容规范', path: '/about' },
      { name: '意见反馈', path: '/about' },
      { name: '商务合作', path: '/about' },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center">
                <i className="ri-leaf-line text-lg text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-semibold whitespace-nowrap text-background-50">
                蘑菇社区
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-sm">
              蘑菇社区是一个充满活力的兴趣交流平台，汇聚海量优质内容与真实用户分享。加入我们，与志同道合的伙伴一起探索精彩世界。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors" aria-label="小红书">
                <i className="ri-reddit-line text-background-50"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-label font-semibold text-sm mb-4 text-background-50">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60 whitespace-nowrap">
            &copy; {currentYear} 蘑菇社区 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-background-50/60 whitespace-nowrap">
            用心连接每一个有趣的灵魂
          </p>
        </div>
      </div>
    </footer>
  );
}